<template>
  <div class="search_nav">
      <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="支付渠道：">
              <el-select style="width: 150px;" v-model="formInline.payType" filterable placeholder="全部">
                  <el-option label="微信" :value="10" />
                  <el-option label="建行" :value="12" />
                  <el-option label="招行" :value="14" />
                  <el-option label="微信支付分" :value="13" />
                  <el-option label="招行微信支付分" :value="15" />
              </el-select>
          </el-form-item>
          <el-form-item label="统计时间：">
              <el-date-picker
                  v-model="formInline.dateRange"
                  type="daterange"
                  value-format="YYYY-MM-DD"
                  range-separator="至"
                  start-placeholder="起始日期"
                  end-placeholder="截止日期"
                  style="width: 280px;"
              />
          </el-form-item>
          <el-form-item>
            <div class="button_group">
              <el-button type="primary" @click="getList">搜索</el-button>
              <el-button type="primary" @click="supplementOrder">补充订单</el-button>
              <el-button type="primary" @click="getList">刷新</el-button>
              <el-button type="primary" @click="exportData">导出</el-button>
          </div>
          </el-form-item>
      </el-form>
  </div>

  <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
    <el-table-column label="统计时间" width="120">
      <template #default="scope">
        <span>{{ scope.row.dateTimeStr || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="总交易金额">
      <template #default="scope">
        <span>{{ scope.row.totalAmt === null || scope.row.totalAmt === '' || scope.row.totalAmt === undefined ? '--' : (scope.row.totalAmt || '0.00') }}</span>
      </template>
    </el-table-column>
    <el-table-column label="渠道手续费">
      <template #default="scope">
        <span>{{ scope.row.handlingFee === null || scope.row.handlingFee === '' || scope.row.handlingFee === undefined ? '--' : (scope.row.handlingFee || '0.00') }}</span>
      </template>
    </el-table-column>
    <!-- <el-table-column label="渠道退款">
      <template #default="scope">
        <span>{{ scope.row.refundAmt === null || scope.row.refundAmt === '' || scope.row.refundAmt === undefined ? '--' : (scope.row.refundAmt || '0.00') }}</span>
      </template>
    </el-table-column> -->
    <el-table-column label="渠道入账金额">
      <template #default="scope">
        <span>{{ scope.row.creditedAmt === null || scope.row.creditedAmt === '' || scope.row.creditedAmt === undefined ? '--' : (scope.row.creditedAmt || '0.00') }}</span>
      </template>
    </el-table-column>
  </el-table>

  <!-- 分页 -->
  <Pagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
  />

  <!-- 补充订单弹窗 -->
  <el-dialog
      title="补充订单"
      v-model="dialogVisible"
      width="500px"
  >
    <el-form :model="supplementForm" label-width="80px">
      <el-form-item label="*时间：" prop="supplementDate">
        <el-date-picker
            v-model="supplementForm.supplementDate"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="请选择日期"
            style="width: 300px;"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveSupplement">保存</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>

</template>

<script>
import { ElMessage } from 'element-plus';
import moment from 'moment';

export default {
name:'MerchantSettlement',
data() {
return {
    tableData: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    payWayName: '微信',
    formInline: {
        payType: 10,
        // 时间范围，默认当月到当天
        dateRange: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    },
    dialogVisible: false,
    supplementForm: {
        supplementDate: ''
    }
}
},
mounted(){
this.getList();
},
methods:{
getList(){
    let that = this;
    let param = {};
    param.page = that.currentPage;
    param.pageSize = that.pageSize;
    param.payType = that.formInline.payType;
    if (this.formInline.dateRange && this.formInline.dateRange.length > 0) {
        param.startDateStr = this.formInline.dateRange[0];
        param.endDateStr = this.formInline.dateRange[1];
    }
    
    that.$axios.post(that.$store.state.platformApi + "settleBill/page", JSON.stringify(param)).then(result => {
        if(result.code == 200){
            that.tableData = result.data.records || [];
            that.total = result.data.total || 0;
        }
    });
},
handleSizeChange(val) {
    this.pageSize = val;
    this.getList();
},
handleCurrentChange(val) {
    this.currentPage = val;
    this.getList();
},
supplementOrder() {
    // 打开补充订单弹窗
    this.dialogVisible = true;
    this.supplementForm.supplementDate = '';
},
// 保存补充订单
saveSupplement() {
    if (!this.supplementForm.supplementDate) {
        this.$message.error('请选择日期');
        return;
    }
    let that = this;
    let param = {
      payType: that.formInline.payType,
      fillTimeStr: this.supplementForm.supplementDate
    };
    that.$axios.post(that.$store.state.platformApi + "settleBill/fill", JSON.stringify(param)).then(result => {
        if(result.code == 200){
            that.$message.success('操作成功，待数据拉取完成后刷新表格');
            that.dialogVisible = false;
        }
    });
},
exportData() {
    let that = this;
    let param = {};
    if (this.formInline.dateRange && this.formInline.dateRange.length > 0) {
        param.startDateStr = this.formInline.dateRange[0];
        param.endDateStr = this.formInline.dateRange[1];
    }
    that.$axios.post(that.$store.state.platformApi + "settleBill/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
        // 处理下载
    });
}
}
}
</script>

<style lang="scss" scoped>
.search_nav{
padding: 15px;
background: #fff;
margin-bottom: 15px;
}
.button_group{
display: flex;
align-items: center;
justify-content: flex-end;
button{
    margin-left: 10px;
}
}
.dialog-footer{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>